// removed by extract-text-webpack-plugin
module.exports = {"icon":"lf_lg","iconSaved":"lf_lh","iconText":"lf_li","iconTextSaved":"lf_lj","hoverPlaceholder":"lf_lk","container":"lf_g","dropdown":"lf_ll","dropdownTitle":"lf_lm","dropdownDescription":"lf_ln","dropdownRaces":"lf_lo","dropdownRace":"lf_lp","dropdownRaceSaved":"lf_lq","arrowBox":"lf_lr"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/EventHeader/ExternalBookingButton/styles.module.css
// module id = 1280
// module chunks = 27